export default __webpack_public_path__ + "static/media/pepperoni.0e802afd.jpg";